<template>
  <v-form ref="temasForm">
    <v-select
      id="temas-select"
      v-model="filter.solucaoTipoId"
      item-text="solucaoTipoNome"
      item-name="solucaoTipoNome"
      item-value="solucaoTipoId"
      :items="tipoSolucoes"
      label="Tipo Solução"
      placeholder="Selecione..."
      v-on:change="$emit('onChange')"
      :disabled="disabled"
    >
      <template slot="no-data"> Nenhum Tipo Solução </template>
    </v-select>
  </v-form>
</template>

<script>
import { tipoSolucaoAPI } from "../API/TipoSolucaoAPI";
import { mapActions } from "vuex";

export default {
  name: "TipoSolucaoCombobox",
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false },
  },
  async mounted() {
    await this.load();
  },

  methods: {
    ...mapActions(["setLoading"]),
    rules() {},

    validate() {
      return this.$refs.temasForm.validate();
    },
    load() {
      return tipoSolucaoAPI
        .list()
        .then((resp) => {
          this.tipoSolucoes = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      tipoSolucoes: [],
    };
  },
};
</script>
